import { Record } from "immutable";

import { syncStatusOptions } from "../../../../constants/syncStatus";
import createFromJS from "../../../createFromJS";

export const TreeViewItemRecord = Record({
  id: null,
  index: null,
  label: null,
  icon: null,
  status: syncStatusOptions.DETECTED_NO_CHANGE,
  childStatus: syncStatusOptions.DETECTED_NO_CHANGE,
  statusIcon: null,
  labelColor: null,
  iconColor: null,
  statusColor: null,
  statusIconIdentifier: null,
  statusLabel: null,
  children: null,
  type: null,
  placeholder: null
});

const data = {
  collections: {
    children: "TreeViewItemRecord"
  }
};

createFromJS.registerCallback("TreeViewItemRecord", createFromJS.createNestedCallback(TreeViewItemRecord, data));
